var ApolloSlick = function(jQ) {

    function initSlicks ($slicks) {
        $slicks.each(function() {
            var $slick = jQ(this);
            $slick.slick({
                mobileFirst: true,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: "unslick"
                    }
                ]
            });
        });

        $(window).on('resize orientationchange', function() {
            $slicks.each(function() {
                var $slick = jQ(this);
                $slick.slick('resize');
            });
        });
    }

    function init() {
        
        if (DEBUG) console.info("ApolloSlick.init()");

        var $slicks = jQuery('.ap-slick');
        if (DEBUG) console.info(".ap-slick elements found: " + $slicks.length);
        if ($slicks.length > 0) {
            initSlicks($slicks);
        }
    }

    // public available functions
    return {
        init: init
    }

}(jQuery);
